import api from './api';

export type SellerOverview = {
  seller: { name: string };
  kpis: {
    totalListings: number;
    activeListings: number;
    totalViews: number;
    totalLeads: number;
    listingsThisMonth: number;
    listingsPreviousMonth: number;
    leadsThisMonth: number;
    leadsPreviousMonth: number;
    viewsThisMonth?: number;
    viewsPreviousMonth?: number;
    profileViews?: number;
    profileViewsThisMonth?: number;
    profileViewsPreviousMonth?: number;
  };
  monthlyLeads: { month: string; leads: number }[];
  monthlyViews?: { month: string; views: number }[];
  recentListings: { id: string; Title: string; Category?: string; Price?: string | number | null; Images: string[]; ViewCount: number; IsActive: boolean; leads: number }[];
  recentLeads: { id: string; BuyerName: string; LeadSource: string; CreatedAt: string; Vehicle: { id?: string; Title: string } }[];
  complaints: { open: number; pendingResponse: number; resolved: number; urgentComplaint: { id: string } | null };
};

export const getSellerOverview = async (): Promise<SellerOverview> => {
  const response = await api.get('/dashboard/overview');
  return response.data.data;
};
